import {ProductFacts} from "@app/core/product/domain/dtos/product-facts";
import {CategoryMapper} from "@app/core/category/infrastructure/mappers/category.mapper";
import {QualityStampMapper} from "@app/core/product/infrastructure/mappers/quality-stamp.mapper";

export class ProductFactsMapper {
    static deserialize(param: any): ProductFacts {
        return {
            categories: param.categories ? param.categories.map(CategoryMapper.deserialize) : [],
            cookingTemperatureFrom: param.cooking_temperature_from,
            cookingTemperatureTo: param.cooking_temperature_to,
            thawingTimeFrom: param.thawing_time_from,
            thawingTimeTo: param.thawing_time_to,
            cookingTimeFrom: param.cooking_time_from,
            cookingTimeTo: param.cooking_time_to,
            fermentationTimeFrom: param.fermentation_time_from,
            fermentationTimeTo: param.fermentation_time_to,
            paletBoxesLayer: param.palet_boxes_layer,
            paletLayers: param.palet_layers,
            longitude: param.longitude,
            weight: param.weight,
            energeticValKj: param.energetic_val_kj,
            energeticValKcal: param.energetic_val_kcal,
            fats: param.fats,
            saturatedFats: param.saturated_fats,
            monounsaturatesFats: param.monounsaturates_fats,
            polyunsaturatesFats: param.polyunsaturates_fats,
            carbohydrates: param.carbohydrates,
            sugar: param.sugar,
            fiber: param.fiber,
            protein: param.protein,
            salt: param.salt,
            o3FattyAcids: param.o3_fatty_acids,
            allergensIngredient: param.allergens_ingedient ?? [],
            allergensContamination: param.allergens_contamination ?? [],
            qualityStamps: param.quality_stamps ? param.quality_stamps.map(QualityStampMapper.deserialize) : [],
            ingredients: param.ingredients
        } as ProductFacts

    }
}
